export default __webpack_public_path__ + "static/media/health-summary-menu-onboarding-carousel-web.5c8ac52c.png";